import React from 'react';

import { ReactThreeFiber } from 'react-three-fiber';
import { useTexture } from '../../../hooks';
import { Mesh, Geometry, BufferGeometry, Material } from 'three';
import Button from '../button';

type ImageButtonProps = ReactThreeFiber.Object3DNode<Mesh<Geometry | BufferGeometry, Material | Material[]>, typeof Mesh> & {
  src: string;
  width?: number;
  height?: number;
  position?: ReactThreeFiber.Vector3;
  rotation?: ReactThreeFiber.Euler;
  onClick: (e?: any) => void;
};

const ImageButton = ({ src, width = 0.1, height = 0.1, position, rotation, onClick, ...props }: ImageButtonProps) => {
  const { texture } = useTexture(src);
  const { texture:playButtonTexture } = useTexture('https://cdn.campus360.org/uploads/icons/video_play.png') ;

  return (
    <mesh position={position} rotation={rotation} {...props}>
      <planeBufferGeometry args={[width, height]} attach="geometry" />


      <Button onClick={onClick} defaultState={{
        main: {
          width: width,
          height: height,
          material: { transparent: true, map: texture },
        },
      }} hoverState={
      {main: {
        scale: [1, 1, 1]
      },}
      } />
      <Button onClick={onClick} defaultState={{
        main: {
          width: 0.117,
          height: 0.117,
          material: { transparent: true, map: playButtonTexture},
        },
      }} hoverState={
        {main: {
            scale: [1, 1, 1]
          },}
      } />
    </mesh>
  );
};

export default ImageButton;
